import { Icon, chevronUp, chevronDown } from '@wordpress/icons';
const {
  components: { Tooltip },
  blockEditor: { useSettings },
} = wp;

const FocusableIcon = ({
  title,
  attributes = {},
  setAttributes = () => {},
}) => {
  const { isCollapsed, label } = attributes;
  const [focusableBlockIcons] =
    useSettings(`custom.focusableBlockIcons`) ?? false;
  const collapsibleIconText = isCollapsed ? 'Expand' : 'Collapse';
  return (
    focusableBlockIcons && (
      <div className="focusable-block-icon-wrapper">
        <Tooltip text={label || title}>
          <span className="focusable-block-icon">{label || title}</span>
        </Tooltip>
        {typeof isCollapsed !== 'undefined' && (
          <Tooltip text={collapsibleIconText}>
            <Icon
              onClick={() => setAttributes({ isCollapsed: !isCollapsed })}
              icon={isCollapsed ? chevronUp : chevronDown}
              className="collapsible-block-icon"
            />
          </Tooltip>
        )}
      </div>
    )
  );
};
export default FocusableIcon;
